module.exports = __webpack_public_path__ + "img/dns.9f4edc9d.svg";